import { ArrowDownUp } from "lucide-react";
import { useMemo } from "react";
import { Link } from "react-router-dom";

interface ColumnProps {
  columnName: (data: any) => void;
  onClickDelete: (data: any) => void;
}

const CommitMentColumn = ({ columnName, onClickDelete }: ColumnProps) => {
  const CommitMentColumn = useMemo(
    () => [
      {
        header: () => (
          <span
            className="flex"
            onClick={() => columnName("commitment_number")}
          >
            شماره قرارداد
            <ArrowDownUp size={15} className="text-blue-500 gap-2" />
          </span>
        ),
        accessorKey: "commitment_number",
        enableColumnFilter: true,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
      },
      {
        header: () => (
          <span className="flex">
            نام کشاورز
            {/* <ArrowDownUp size={15} className="text-blue-500 gap-2" /> */}
          </span>
        ),
        accessorKey: "farmer_name",
        enableColumnFilter: false,
      },
      {
        header: "نام روستا",
        accessorKey: "village_name",
        enableColumnFilter: true,
      },
      {
        header: () => (
          <span className="flex" onClick={() => columnName("amount_of_land")}>
            مقدار زمین(هکتار)
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),
        accessorKey: "amount_of_land",
        enableColumnFilter: true,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: () => (
          <span
            className="flex"
            onClick={() => columnName("withdrawal_amount")}
          >
            میزان برداشت (تن)
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),
        accessorKey: "withdrawal_amount",
        enableColumnFilter: true,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },

      {
        header: "تاریخ قرارداد",
        accessorKey: "date_set",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ  ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },

      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <button
              className="flex mx-3 items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </button>
          </div>
        ),
      },
    ],
    []
  );
  return CommitMentColumn;
};

export default CommitMentColumn;
